export default __webpack_public_path__ + "static/media/19t.c42fa515.jpg";